import type { OverviewChartId } from "../types";

import { AdsManagerContent } from "./AdsManagerContent";
import { OverviewTabContent } from "./overview/OverviewTabContent";

type OverviewTabProps = {
  onOpenMonth: (monthIndex: number) => void;
  leftChart: OverviewChartId;
  rightChart: OverviewChartId;
};

export function OverviewTab({
  onOpenMonth,
  leftChart,
  rightChart,
}: OverviewTabProps) {
  return (
    <AdsManagerContent className="py-8 pb-32">
      <OverviewTabContent
        onOpenMonth={onOpenMonth}
        leftChart={leftChart}
        rightChart={rightChart}
      />
    </AdsManagerContent>
  );
}
